import React from 'react';
import axios from 'axios'
import { Table, Input, Button,Collapse,Popover,Popconfirm,message,Spin,Tabs } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,FundViewOutlined,LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import * as serverconfig from '../serverconn'
import WorkFlowForm from '../components/WorkFlowForm';
import CompanyUpdateForm from '../components/CompanyUpdateForm';
import WorkFlowActionMapping from './WorkFlowActionMapping';
import WorkFlowUpdateForm from '../components/WorkFlowUpdateForm';
import WorkFlowApplicationFields from './WorkFlowApplicationFields';


var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

function callback(key) {
  console.log(key);
}
const { TabPane } = Tabs;


var token= ''
var bizuserid= ''


class WorkFlows extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    workflows: [],
    datarequested:true,

  };

  componentDidMount(){
    this.comp_reloaded()
    
}

comp_reloaded=()=>{

  if(localStorage.getItem("token")){
     token= localStorage.getItem("token")
  }else{
     token= ''
  }

  if(localStorage.getItem("bizuserid")){
    bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
 }else{
    bizuserid= ''
 }

  axios.defaults.headers={
    "Content-Type":"application/json",
    Authorization:`Token ${token}`
  }

  axios.get(serverconfig.backendserverurl+`/api/workflows/`)
  .then(res => {
      this.setState({
        workflows:res.data
      })

      this.setState({datarequested:false})


  })



}



getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  this.setState({
    searchText: selectedKeys[0],
    searchedColumn: dataIndex,
  });
};

handleReset = clearFilters => {
  clearFilters();
  this.setState({ searchText: '' });
};



  render() {
    const columns = [
    
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'id',
        ...this.getColumnSearchProps('name'),
      },
     
      {
        title: 'Type ',
        dataIndex: 'workflow_type',
        key: 'id',
        ...this.getColumnSearchProps('workflow_type'),
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'id',
      },
     
      {
        title: 'Active',
        dataIndex: 'active',
        key: 'id',
        render: text =>
          <p>{text===true?"Yes":"No"}</p>
      },
      {
        title: 'Licences',
        dataIndex: 'licence_types',
        key: 'id',
      },
     
    ];

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
                <div className="content" />
              </Spin>      
         </div>
      )

    }else{
      return(
        <div>

          <Tabs
            defaultActiveKey="1"
            onChange={() => {}}
            tabPosition={'top'}
          >
             <TabPane tab={"Work Flows"} key="1">
                    <p>There are {this.state.workflows.length} Work Flows in the list </p>
                      <Table 
                        columns={columns} 
                        scroll={{ x: 1000 }}
                        pagination={{showQuickJumper:true,showSizeChanger:true }}
                        dataSource={this.state.workflows}
                        bordered
                        
                        expandable={{
                          expandedRowRender: (record) =>{
                              return (
                                <div>
                               <Tabs
                                  defaultActiveKey="1"
                                  onChange={() => {}}
                                  tabPosition={'top'}
                                >

                                  <TabPane tab={"Details/Update"} key="1">
                                    <WorkFlowUpdateForm workflow={record} onRefresh={this.comp_reloaded} />
                                  </TabPane>

                                  <TabPane tab={"Action Series"} key="2">
                                    <WorkFlowActionMapping workflow_id={record.id} />
                                  </TabPane>

                                  <TabPane tab={"Application Form Fields"} key="3">
                                    <WorkFlowApplicationFields workflow_obj={record} />
                                  </TabPane>

                                </Tabs>

                                </div>
                              );
                          } ,
                          rowExpandable: (record) => true,
                          onExpand:(condition,record)=>{
                          },
                        }}
                        
                        />
              </TabPane>

              <TabPane tab={"New Work Flow"} key="2">
                <WorkFlowForm onRefresh={this.comp_reloaded}/>
              </TabPane>

              </Tabs>

        </div>)

    }

   
  }
}

export default WorkFlows; 
